import React  from 'react';
import { useHistory } from "react-router-dom";
import dotBtnImg from 'images/dotbtn.png';
import plusIcon from 'images/plus_icon.png';
import TitleHeader from 'components/presenters/header/TitleHeader';
import { DotBtn, Setlistinner, Setlist, SetlistSpan, Setlistname, Setlistcont, AddbtnBox, Addbtn, AddText } from './style';

export default function RoutineList({setModalOption,setTextModalShow,updateNext,routineInfo,setCurrentPostIndex}) {
    const history = useHistory();
    let length = routineInfo.length
    const Addrutine=()=>{
        if(length >= 5) {
            setModalOption("routinetxt");
            setTextModalShow(true);
        }
        else {
            //updateNext(1);
            history.push('/routine/create');
        }
    } 
    return(
        <>
        <TitleHeader title={"루틴 관리"} borderbottom={"solid calc(100vw*(1/375)) #d5d5d5"} />
        <Setlistinner>
            {
                routineInfo.map((value)=>{
                return <Setlist key={`routine-list-item-${value['no']}`}>
                            <SetlistSpan >
                                <Setlistname>{value.title}</Setlistname>
                                <Setlistcont>
                                    <DotBtn onClick={()=>{setModalOption("routine");setCurrentPostIndex(value.no)}}><img src={dotBtnImg} /></DotBtn>
                                </Setlistcont>
                            </SetlistSpan>
                        </Setlist>;
                    })
            }
        </Setlistinner>
        <AddbtnBox onClick={Addrutine} >
            <Addbtn><img src={plusIcon} /></Addbtn>
            <AddText>루틴 추가하기</AddText>
        </AddbtnBox>
    </>

    )
}
